import { Carousel } from "bootstrap";

$(function() {
	$('.product-slider-images').each(function(index, item) {
		var carouselElement = $(item).find('.carousel.slide');
		if(carouselElement) {
			var carousel = new Carousel(carouselElement, {
				interval: 5000,
			});
		}
	});
});